import React from 'react';
import { GivelifyLabel, BasicPageWrapper } from '@givelify/ui';
import { PAGE_NAME, TrackingProvider } from '@givelify/utils';
import { Grid } from '@mui/material';
import { useTranslations } from '../../utils/translations';
import { DashboardTile } from './components';
import { useFundraisingToolsDashboard } from './useFundraisingToolsDashboard';

const FundraisingToolsRootView: React.FCC = () => {
    const { dashboardTiles, isMobile } = useFundraisingToolsDashboard();
    const copy = useTranslations('root', ['title', 'description']);

    return (
        <BasicPageWrapper
            showDivider
            description={copy.description}
            title={copy.title}
        >
            <GivelifyLabel
                marginBottom={1}
                marginTop={1}
                text={copy.description}
                variant="body1"
            />
            <Grid container spacing={isMobile ? 2 : 3}>
                {dashboardTiles.map((tile, index) => (
                    <Grid key={index} item md={4} mobile={12} sm={6}>
                        <DashboardTile
                            description={tile.description}
                            href={tile.href}
                            icon={tile.icon}
                            onClick={tile.onClick}
                            title={tile.title}
                        />
                    </Grid>
                ))}
            </Grid>
        </BasicPageWrapper>
    );
};

export const FundraisingToolsRoot: React.FC = () => {
    return (
        <TrackingProvider trackPageVisit pageName={PAGE_NAME.GivingTools}>
            <FundraisingToolsRootView />
        </TrackingProvider>
    );
};
